export const ROUTE_PATHS = {
  HOME: '/'
} as const;

export interface Specialty {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export interface Formation {
  id: string;
  title: string;
  institution?: string;
  year?: string;
  description?: string;
}

export interface Methodology {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export interface Project {
  id: string;
  title: string;
  description: string;
  type: 'video' | 'podcast' | 'content';
}

export interface Book {
  id: string;
  title: string;
  subtitle?: string;
  description: string;
  edition?: string;
  coverImage?: string;
}

export const specialties: Specialty[] = [
  {
    id: 'ansiedade',
    title: 'Ansiedade',
    description: 'Compreensão e transformação de padrões ansiosos através de técnicas integrativas.',
    icon: 'brain'
  },
  {
    id: 'depressao',
    title: 'Depressão',
    description: 'Acolhimento e ressignificação de estados depressivos com abordagem profunda.',
    icon: 'heart'
  },
  {
    id: 'relacionamentos',
    title: 'Relacionamentos',
    description: 'Terapia individual e de casal para construção de vínculos saudáveis.',
    icon: 'users'
  },
  {
    id: 'autoconhecimento',
    title: 'Autoconhecimento',
    description: 'Jornada de descoberta interior e desenvolvimento da consciência emocional.',
    icon: 'compass'
  },
  {
    id: 'bloqueios',
    title: 'Bloqueios Emocionais',
    description: 'Identificação e dissolução de padrões limitantes inconscientes.',
    icon: 'unlock'
  },
  {
    id: 'desenvolvimento',
    title: 'Desenvolvimento Emocional',
    description: 'Fortalecimento da inteligência emocional e maturidade psicológica.',
    icon: 'trending-up'
  },
  {
    id: 'crises',
    title: 'Crises Existenciais',
    description: 'Acompanhamento em momentos de transição e questionamentos profundos.',
    icon: 'help-circle'
  },
  {
    id: 'traumas',
    title: 'Traumas Emocionais',
    description: 'Ressignificação de experiências traumáticas com técnicas especializadas.',
    icon: 'shield'
  },
  {
    id: 'proposito',
    title: 'Propósito de Vida',
    description: 'Busca de sentido e direcionamento através da logoterapia aplicada.',
    icon: 'target'
  }
];

export const formations: Formation[] = [
  {
    id: 'psicanalise',
    title: 'Formação em Psicanálise',
    description: 'Formação completa em teoria e prática psicanalítica'
  },
  {
    id: 'pnl',
    title: 'Programação Neurolinguística (PNL)',
    description: 'Certificação em técnicas de PNL para transformação de crenças'
  },
  {
    id: 'hipnose',
    title: 'Hipnose Clínica',
    description: 'Especialização em hipnose terapêutica e regressão'
  },
  {
    id: 'integrativas',
    title: 'Terapias Integrativas',
    description: 'Formação em abordagens holísticas e integrativas'
  },
  {
    id: 'inteligencia',
    title: 'Inteligência Emocional',
    description: 'Especialização em desenvolvimento emocional'
  },
  {
    id: 'logoterapia',
    title: 'Logoterapia Aplicada',
    description: 'Formação em logoterapia e análise existencial'
  },
  {
    id: 'comportamental',
    title: 'Psicoterapia Comportamental',
    description: 'Técnicas comportamentais aplicadas à prática clínica'
  },
  {
    id: 'abraph',
    title: 'Membro ABRAPH',
    institution: 'Academia Brasileira de Psicoterapia Holística',
    description: 'Registro profissional e certificação'
  },
  {
    id: 'ath',
    title: 'Membro ATH',
    institution: 'Associação de Terapeutas Holísticos',
    description: 'Filiação profissional e reconhecimento'
  }
];

export const methodologies: Methodology[] = [
  {
    id: 'psicanalise',
    title: 'Psicanálise',
    description: 'Exploração do inconsciente e compreensão de padrões emocionais profundos através da análise psicanalítica.',
    icon: 'brain'
  },
  {
    id: 'hipnose',
    title: 'Hipnose Terapêutica',
    description: 'Acesso a conteúdos emocionais profundos e ressignificação de experiências através do estado hipnótico.',
    icon: 'eye'
  },
  {
    id: 'pnl',
    title: 'Programação Neurolinguística',
    description: 'Transformação de crenças limitantes e reprogramação de padrões mentais através de técnicas de PNL.',
    icon: 'zap'
  },
  {
    id: 'logoterapia',
    title: 'Logoterapia',
    description: 'Busca de sentido e propósito de vida através da análise existencial e logoterapia aplicada.',
    icon: 'compass'
  },
  {
    id: 'integrativas',
    title: 'Terapias Integrativas',
    description: 'Integração entre mente, emoções e comportamento através de abordagens holísticas e complementares.',
    icon: 'layers'
  }
];

export const projects: Project[] = [
  {
    id: 'minuto-essencial',
    title: 'Minuto Essencial',
    description: 'Série de reflexões terapêuticas que ajudam pessoas a desenvolver consciência emocional e autoconhecimento através de conteúdos breves e profundos.',
    type: 'content'
  },
  {
    id: 'faz-sentido',
    title: 'Faz Sentido, Erick?',
    description: 'Programa de reflexões profundas sobre vida, emoções, espiritualidade e comportamento humano, explorando questões existenciais contemporâneas.',
    type: 'podcast'
  }
];

export const books: Book[] = [
  {
    id: 'vivendo-genuinamente-1',
    title: 'Vivendo GenuinaMente',
    edition: 'Primeira Edição',
    description: 'Uma obra que convida o leitor a viver de forma autêntica e consciente, explorando caminhos para uma vida genuína e alinhada com a essência interior.',
    coverImage: 'book-vivendo-1'
  },
  {
    id: 'vivendo-genuinamente-2',
    title: 'Vivendo GenuinaMente',
    edition: 'Segunda Edição',
    description: 'Edição revisada e ampliada da obra sobre autenticidade e consciência, com novos insights sobre o viver genuíno no mundo contemporâneo.',
    coverImage: 'book-vivendo-2'
  },
  {
    id: 'dialogo-criador',
    title: 'Diálogo com o Criador',
    description: 'Uma jornada profunda de perguntas humanas e reflexões espirituais sobre fé, propósito e existência, explorando o diálogo entre o humano e o divino.',
    coverImage: 'book-dialogo'
  }
];

export const CONTACT_INFO = {
  whatsapp: '+5511949851250',
  instagram: '@ericktorritezi.oficial',
  youtube: '@ericktorritezi',
  email: 'contato@ericktorritezi.com.br'
} as const;
